import { initStorageManager } from 'utils/customStorage.util';

const storage = initStorageManager(() => sessionStorage);
export const showAlertFromSession = (sessionKey: string) => {
  const alertMessage = storage.getItem(sessionKey);
  if (alertMessage) {
    alert(alertMessage);
    storage.removeItem(sessionKey);
  }
};
